import { schemaId } from 'cpool-schemas';
import { z } from 'zod';

export const LoanRequestsViewedByTableDefinitionZod = z.object({
    loanRequestId: schemaId,
    timestamps: z.array(z.coerce.date()),
    userId: schemaId,
});

export type LoanRequestsViewedByTableSchema = z.infer<typeof LoanRequestsViewedByTableDefinitionZod>;
